<template>
  <div class="recharge" style="margin-top:8px;">
    <b-button :disabled="meter.min_charge_value==0" v-if="meter.payment_mode == '1'" @click="initialize()"  v-b-modal.modalPopover class="btn-primary" id="post-recharge-btn">{{$t("pay_bills") }}</b-button>
    <b-button v-if="meter.payment_mode == '2'"  @click="initialize()" v-b-modal.modalPopover class="btn-primary" id="pre-recharge-btn">{{$t("recharge") }}</b-button>

    <b-modal 
      id="modalPopover" 
      ref="modalPopover"
      @hide="reset"
      size="m" 
      centered 
      scrollable 
      :header-class="{'right-dir' : lang==2 , 'left-dir' : lang==1}" 
      >
          <template #modal-title>
            <div class="recharge-header" :class="{'rtl':  lang ==1,'ltr': lang ==2 ,}" >
              <p>{{$t("meter_no")}}</p>

              <p>
                <i v-if="meter.mdm_utilities == '1'" class="pylon-icon-Electric"></i>
                <i v-if="meter.mdm_utilities == '2'" class="fas fa-burn"></i>
                <i v-if="meter.mdm_utilities == '3'" class="pylon-icon-Water"></i>
                {{ code }}           
              </p>
            </div>

            <div v-if="meter.payment_mode == '1'" class="recharge-header" :class="{'rtl': lang ==1, 'ltr': lang ==2,}" >
              <p >{{ $t("required_money") }}</p>
              <p><span :class="{'change-dir': lang ==1, }">{{ meter.min_charge_value }}</span> <span > {{$t('egp')}}  </span> </p>
            </div>

            <div v-if="meter.payment_mode == '2'" class="recharge-header" :class="{ 'rtl': lang ==1,'ltr': lang ==2,  }">
                <p >{{ $t("remaining_credit") }}</p>
                <p> <span  :class="{ 'change-dir': lang ==1,  }" > {{ meter.current_credit }}</span><span > {{$t('egp')}} </span></p>
            </div>

          </template>

          <div :class="{'rtl': lang ==1,'ltr': lang ==2,}">
            
              <div v-if="error" class="recharge-alret alert alert-danger "  style="min-height: 80px;" role="alert">
                    <b >{{$t('error')}}</b>
                    <span style="display:block" >{{msg}}</span> 
              </div>

              <div class="due-parent">
                <div  class="due-block" >
                  
                    <div v-if="meter.customer_on_account!=null && meter.customer_on_account > 0" class="alret alert-info alret-note d-flex align-items-center" :class="{'cancel-margin' : error==true}"  style="gap: 12px;color: rgb(79, 77, 97) !important;min-height: 60px;    margin-bottom: 8px;">
                      <i class="pylon-icon-Warning"  style="color: #007EFF;"></i> 
                      <span>{{$t("you_have_installement")}} <span class="dues-val">({{meter.customer_on_account}} {{ $t("egp") }})</span> {{ $t("installment_note") }} </span>
                    </div>
                    
                    <div class="alret alert-warning " :class="{'cancel-margin' : error==true}" v-if="have_due_payments" style="gap: 12px; color:#4F4D61 !important ;border-radius: 8px;min-height: 60px;padding-bottom:8px;    margin-bottom: 10px;">
                    
                      <div class="alret-note d-flex align-items-center" style="gap: 12px; color: rgb(79, 77, 97) !important;">
                          <i class="pylon-icon-Warning"  style="color: #FFCC1F;"></i> 
                          <span v-if="meter.payment_mode=='2'">{{$t("you_have_dues")}} <span class="dues-val">({{due_payments}} {{ $t("egp") }})</span> {{ $t("due_note") }}
                            <span v-if="!show_clicked"  @click="showDueDetails(false)" class="details-span">{{$t("Show_Details")}}<i class="pylon-icon-Arrow-Down"></i></span>
                            <span v-if="show_clicked" @click="showDueDetails(true)"  class="details-span"> {{$t("Hide_Details")}}<i class="pylon-icon-Arrow-Up"></i></span>
                          </span>
                          <span v-else>{{ $t("post_due_note") }}</span>
                      </div> 

                      <ul class="dues-details" v-if="(show_clicked || meter.payment_mode=='1') && company.show_due_payments">
                        <li v-for="(item,index) in due_payment_services" :key="index" >   
                            <div>
                              <span style="font-weight:600 !important">{{item.name}} </span>
                              <span class="due-payment__amount" > {{item.amount}} {{$t("egp")}}</span>
                            </div>
                        </li>
                        <div class="separator"></div>
                        <div class="total-dues-val">
                          <span style="font-weight:600 !important">{{ $t("total") }}</span>
                          <span class="due-payment__amount"> {{due_payments}} {{$t("egp")}}</span>
                        </div>
                      </ul>

                    </div>

                    <div class="mb-2" v-if="meter.payment_mode=='2'">   
                      <p class="enter_amount">{{$t("enter_amount")}}</p>                    
                      <div  style="display:flex;justify-content:space-between">
                        <div>
                            <p style="font-weight:500 !important">{{$t("amount")}}</p>                
                            <div class="relative">
                              <input  class=" chargeInput" id="min-recahrge-amount" v-model="chargeAmount"  :placeholder="chargeAmountPlaceHolder" />
                              <span  class="min-span">  {{$t('min_amount')}} ( {{ min_payment_value}} {{$t('egp')}} )</span>                            
                            </div>
                        </div>
                        <div class="exchange-icons">
                          <i class="pylon-icon-ArrowRight" style="margin-bottom: -4px;"></i>
                          <i class="pylon-icon-Arrow-Left" style=" margin-top: -3px;"></i>
                        </div>
                        <div>
                            <p style="font-weight:500 !important">{{$t("Net_Charge")}}</p> 
                            <div class="relative">
                              <input  class=" chargeInput" id="net-recahrge" v-model="netCharge" :placeholder="chargeAmountPlaceHolder"/>
                            </div>
                        </div>
                      </div> 
                    </div>
                
                </div>
              </div>
            
          </div>
          
          <template #modal-footer >
            <div  class="last-due-element" :class="{'rtl': lang ==1, 'ltr': lang ==2}">
                <DetailedPayment
                  :company="company" 
                  :lang="lang" 
                  :due_payments="due_payments"
                  :financial_dues="meter.customer_on_account" 
                  :chargeAmount="netCharge || chargeAmount" 
                  :collection_fees="collection_fees" 
                  :total_amount="total_amount" 
                  :payment_mode="meter.payment_mode"/>

                <b-button
                  id="recharge-handling-btn"
                  class="btn-color"
                  :disabled="disable_pay"
                  v-b-modal.paymentConfirmation
                  >{{ $t("pay") }}
                </b-button>            
            </div>

          </template>
             
    </b-modal>
       
    <PaymentConfirmation 
        :company="company"
        :lang="lang" 
        :code="code" 
        :due_payments="due_payments" 
        :chargeAmount="netCharge || chargeAmount" 
        :financial_dues="meter.customer_on_account"
        :collection_fees="collection_fees" 
        :total_amount="total_amount"
        :payment_mode="meter.payment_mode"
        @confirm="handleRecharge()"
    />
    <PayTabs 
        :lang="lang"
        :payLink="payLink"
        ref="paytabs"
        class="mt-3" 
        @clear_amount="clear_amount()"   
    />

  </div>

</template>
<script>
import DetailedPayment from "@/components/Recharge/DetailedPayment.vue"
import PaymentConfirmation from "@/components/Recharge/PaymentConfirmation.vue"
import PayTabs from "@/components/PaymentMethods/PayTabs.vue"
import rechargeServices from '@/services/recharge'

export default {
  name: "Recharge",
  components: {
    DetailedPayment,
    PaymentConfirmation,
    PayTabs
  },
  props: ["code", "meter","company","lang"],
  data() {
    return {
      chargeAmount: 0,
      netCharge:0,
      chargeAmountPlaceHolder: this.$t('recharge_value_placeholder'),
      error:false,
      msg:'',
      have_due_payments:false,
      disable_pay:true,
      due_payment_services:[ ],
      payLink:"",   
      due_payments_used_for_total_amount:0,
      due_payments:0,
      min_payment_value:0,
      show_clicked:false,
      difference:0,

    };
  },
  computed: {
    collection_fees() {

      let total_paid = this.meter.payment_mode=='2' //if prepaid 
                       ?Number(this.chargeAmount) ==0  //not entered amount  (start of popup) //total amount = due payments
                          ?  Number(this.due_payments_used_for_total_amount) 
                          :  Number(this.chargeAmount) //when entred amount //total =charge amount (net charge + due ) 
                       : Number(this.chargeAmount) > 0 //if post paid
                          ? Number(this.chargeAmount) 
                          : 0 ;

        if( total_paid > 0){
          return parseFloat(( total_paid *this.company.fees_precentage ) + this.company.fixed_fees).toFixed(2);
        }
        else {
          return 0 ;
        }
    },

    total_amount() {

      let total_paid = this.meter.payment_mode=='2'
                       ?Number(this.chargeAmount) ==0 
                          ?  Number(this.due_payments_used_for_total_amount) 
                          :  Number(this.chargeAmount)
                       : Number(this.chargeAmount) ;
      
       return parseFloat( total_paid + Number(this.collection_fees) ).toFixed(2);
    
    }
  },
  watch: {
    "meter.v_items_json"() {
      // this.min_payment_value=300;
      // this.meter.customer_on_account=500;
      // this.meter.min_charge_activity_value=1;
      // this.meter.min_charge_value=-200;
      this.due_payment_services = this.meter.v_items_json.map(ele=>{
        return{
          name:ele.Name,
          amount:ele.Value,
          pk:ele.PK,
          select:true,
        }
       
      });
      this.have_due_payments=this.due_payment_services.length!==0;
      // this.have_due_payments=true;
        if(this.have_due_payments){
          // this.due_payments=300;
          this.due_payments = Number(this.due_payment_services.reduce((prevEle,curEle)=> prevEle + parseFloat(curEle.amount),0 ).toFixed(2));
          this.due_payments_used_for_total_amount=this.due_payments;
          if( this.meter.customer_on_account > 0){   // if has installment       
            // on =500 due=200 //min-charge =200-500=-300
            // on =200 due=500 //min-charge =500-200= 300
            this.due_payments_used_for_total_amount = this.meter.min_charge_value < 0 // if installment covered the due payments and remain
                                                     ? 0 
                                                     : parseFloat(Number(this.meter.min_charge_value)); //mean that installments not covered dues
           }
           this.min_payment_value=this.meter.min_charge_activity_value+ this.due_payments_used_for_total_amount ;
           this.max_payment_value=this.meter.max_charge_activity_value+this.due_payments_used_for_total_amount ;
        }
        else{
          this.min_payment_value=this.meter.min_charge_activity_value;
          this.max_payment_value=this.meter.max_charge_activity_value;
        
        }
      
    },
    chargeAmount(newAmount,old) {
      if(this.netCharge >= 0){
        this.error=false;
      }
      newAmount = Number(newAmount) ? Number(newAmount) : 0;
      this.chargeAmount=newAmount;

      if(newAmount)
          this.disable_pay = false ;
      else {
        this.disable_pay = true;
      }

      if(this.meter.payment_mode=='2'){
        if(newAmount==0 ){
          this.netCharge=0;
        }
        else if(newAmount<0){
          this.error=true;
          if(this.difference > 0){
            this.msg=this.$t("negative_amount_with_due_founds_error_msg") + this.difference +" "+this.$t("egp");
          }
          else this.msg=this.$t("negative_amount_error_msg");
          this.disable_pay=true;
        }
       else{
          this.netCharge= 
          this.have_due_payments? //have dues
             this.meter.customer_on_account == 0 ?
                this.chargeAmount-this.due_payments_used_for_total_amount // have dues no installments
            //  :this.difference  +(this.chargeAmount-this.due_payments_used_for_total_amount) // have dues , have installemnts
             :  this.chargeAmount-this.meter.min_charge_value // have dues , have installemnts
          : // no dues
          this.meter.customer_on_account==0? 
              this.chargeAmount  // no dues no install
              :this.chargeAmount + this.meter.customer_on_account; // no dues install
          // this.netCharge=this.netCharge.toPrecision(3)

        }
      }
        
    },
    netCharge(newNet , old){
      if(this.chargeAmount >= 0){
        this.error=false;
      }
      if(this.meter.payment_mode=='2'){
          newNet = Number(newNet) ? Number(newNet) : 0;
          this.netCharge=newNet;
          if(newNet==0){
          this.chargeAmount=0;
          }
          else if(newNet<0){
            this.error=true;
            this.msg=this.$t("negative_net_error_msg");
            this.disable_pay=true;
          }
          else{
             // on =500 due=200 //min-charge =200-500=-300
            // on =200 due=500 //min-charge =500-200= 300
            // charge=net +due => net=charge-due
            this.chargeAmount= 
            this.have_due_payments? //have dues
              this.meter.customer_on_account==0?
                newNet+this.due_payments_used_for_total_amount // have dues no indtallments
                :newNet + this.meter.min_charge_value // have dues , have installemnts
            : // no dues
            this.meter.customer_on_account==0? 
                newNet  // no dues no install
                :newNet - this.meter.customer_on_account; // no dues install
          }

    }
  }   
  },

  methods: {
 
    initialize() {
    //  this.meter.min_charge_value=0; //for testing
     this.chargeAmount = this.meter.payment_mode=='2'?0:this.meter.min_charge_value;
      // if(this.company.force_pay_all===true){
      //   this.disable_pay=true;
      // }
    },
    showDueDetails(show){
     if(show){
      this.show_clicked=false;
     }
     else{
      this.show_clicked=true;
     }

    },
    reset(){
     this.chargeAmount=0;
     this.netCharge=0;
     this.show_clicked=false;
     this.error=false;
    },

    clear_amount() {
      this.chargeAmount = null;
      this.$bvModal.hide('modalPopover');  
    },
    handleRecharge() {
      this.error=false;
      let readyForService=false;
      let amount=0;
      if(this.have_due_payments == false) {
        if(this.meter.payment_mode=='2'){
           readyForService =this.chargeAmount!=null && this.chargeAmount!='' 
                        && parseFloat(this.chargeAmount)>=0 && parseFloat(this.chargeAmount)>=parseFloat(this.meter.min_charge_activity_value)
                        && parseFloat(this.chargeAmount)<=parseFloat(this.meter.max_charge_activity_value) ;
        }

        else {
          readyForService=this.chargeAmount!=null && this.chargeAmount!='' ; //post paid
        } 
        amount= parseFloat(this.chargeAmount).toFixed(2);
      }
      else{
        if(this.meter.payment_mode=='2'){

        readyForService= this.chargeAmount!=null && this.chargeAmount!=''
        ? parseFloat(this.chargeAmount)>=parseFloat(this.min_payment_value)  && parseFloat(this.chargeAmount)<=parseFloat(this.max_payment_value)
        : this.total_amount!='' && this.total_amount!=null;

      }
        else{
          readyForService= this.chargeAmount!=null && this.chargeAmount!='' || this.total_amount!='' && this.total_amount!=null ;
        }
        amount = parseFloat(this.total_amount - this.collection_fees).toFixed(2);
      }
     if(readyForService){    
        rechargeServices.
        rechargeMeter(amount,this.meter.req_trx_master,this.due_payment_services.map((ele)=>{return parseInt(ele.pk)}),this.company.paytabs?"paytabs":"nbe",this.company.response_type)
        .then(data=>{ 
          if(this.company.paytabs){
            if (data.redirect_url !== '') {
               this.payLink=data.redirect_url;
            }
          } 
          else if(this.company.nbe){
            if (data.session_id !== '') {
           checkoutPrepare(data.session_id, data.merchant,data.merch_name, data.total_amount, data.request_number, this.meter.account_reference,data.session_version)
           Checkout.showLightbox()
        }
          }  

        }).catch(err=>{
           this.error=true;
          this.msg=err.message;
      })
     }
     else {
        this.error=true;
        if(this.meter.payment_mode=='2'){
           let min_amount_for_payment=this.min_payment_value;
           let max_amount_for_payment=this.max_payment_value;
       
               if( parseFloat(this.chargeAmount) <   parseFloat(min_amount_for_payment) && this.chargeAmount!=''){
                this.msg=`${this.company.enter_total_recahrge_due?this.$t("min_payment_amount"):this.$t("min_charge_amount")} ${min_amount_for_payment}`;
                }
              else if(parseFloat(this.chargeAmount) >   parseFloat(max_amount_for_payment) && this.chargeAmount!=''){
                this.msg=`${this.company.enter_total_recahrge_due?this.$t("max_payment_amount"):this.$t("max_recharge_amount")} ${max_amount_for_payment}`;
                }
              else{
                this.msg=this.$t("enter_amount_for_payment");
              }
         
        }

        else{
          this.msg=this.$t("enter_amount_for_payment");
        }
      
    }
    },
  },

};
</script>

<style scobed>


.modal-dialog {
  min-height: 680px;
}

.modal-dialog ::-webkit-scrollbar {
  width: 4px;
}

.modal-dialog ::-webkit-scrollbar-thumb {
  border-radius: 4px;
}

@media (min-width: 701px){
  .modal-dialog {
      max-width: 558px;
  }
}

#modalPopover___BV_modal_content_ {
    width: 558px;
    overflow-x: hidden;
    position: relative;
}

@media (max-width:700px){
  #modalPopover___BV_modal_content_ {
    width: 80vw; 
  } 
  .modal-dialog {
    max-width: 80vw;
    margin: 1rem auto;
  }
}


#modalPopover___BV_modal_header_{
  display: block !important;
  margin-bottom: 0px !important;
  background: #F0F0F0;
  height: 94px;
  padding: 18px 24px;
}
#modalPopover___BV_modal_body_{
  padding: 24px;
  height: 488px;
  /* min-height: 291px; */
} 
.modal-body {
  padding: 24px;
  max-height: unset;
  /* min-height: 291px; */
}
 #modalPopover___BV_modal_outer_ .close{
  display: none;
}

#modalPopover___BV_modal_footer_ {
  display: flex;
  justify-content: center;
  padding: 24px;
}
.modal-footer{
  display: none;
}
#modalPopover___BV_modal_footer_>* {
  margin: 0;
}


.change-dir{
float: right;
    direction: ltr;
    margin: 0px 5px;
}

.recharge-header{
  display: flex;
  justify-content: space-between;
}
.recharge-header p{
    font-weight: 500 !important;
    font-size: 18px !important;
    color: #262338;
    margin-bottom: 12px;
}
.recharge-header span{
  font-weight: 500 !important;
} 
.recharge-block{
 
 height: 291px;
}

.last-due-element{
  width: 100%;
}

.last-due-element button{
  text-align: center;
  width: 100% !important;
  height: 40px;
  margin-bottom: 0px !important;
}


.due-block .alret-note{
  font-size: 14px;
  padding: 12px;
  border-radius:8px;
  /* margin-bottom: 16px; */
  /* color:#842029 !important; */
}
.due-block .alret-note span{
  
  font-weight: 500 !important;
}
.due-block .alret-note span.dues-val{
  font-weight: 700 !important; 
}
.due-block .alret-note .details-span{
font-weight: 600 !important;
color: var(--main-color);
cursor: pointer;
}
.dues-details{
  margin-bottom: 0;
}
.ltr .dues-details{
margin-left:36px;

}
.rtl .dues-details{
margin-right:36px;

}
.recharge-alret.alert.alert-danger {
  width: 100% !important;
  margin-bottom: 10px;
}
.recharge-alret p{
  font-weight: 400 !important;
  color:#842029
}
.recharge-block,.due-block{
  position: relative;
}
.recharge-block > p ,.due-block p{
 color: #4F4D61; 
 font-size: 16px;      
}
.due-block p.option-p{
 font-weight: 500 !important;
 font-size: 14px;      
}

.currency-left {
  position: absolute;
  left: 16px;
  top: 8px;
  color: #4F4D61;
}
.currency-right {
  position: absolute;
  right: 16px;
  top: 8px;
  color: #4F4D61;
}


.recharge-block p.charge-amount , .due-block p{
    font-weight: 600 !important;
    margin-bottom: 8px;
}
.min-span{
  margin-top: 8px;
  display: block;
  color:#AAAAB2;
  font-size: 14px;
  font-weight: 500 !important;
}

.chargeInput {
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #AAAAB2;
}
.due-block .amount-apearance{
  display: flex;
  justify-content: space-between;
}
.due-block .cancel{
  color:var(--main-color);
  font-weight: 600 !important;
  font-size: 14px;
  cursor: pointer;
}
.due-block .enter{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: var(--main-color);
  border: 1px solid var(--main-color);
  background: white;
  border-radius: 4px;
  padding: 8px 16px;
  min-width: 147px !important;
  height: 33px;
  font-weight: 600 !important;
  font-size: 14px;
  line-height: 1.2;
}
.due-block button.enter[disabled]{
  opacity: 0.5;
}
/* .due-block .enter i{
  font-size: 10px;
} */
.due-block .due-payments{
  margin-bottom: 24px;
}
.dues-details li div ,.total-dues-val{
  display: flex;
  justify-content: space-between;
  column-gap: 16px;
  align-items: center; 
 font-weight: 600;
 font-size: 14px;
 margin-bottom: 8px;
}
.ltr .dues-details li div,.ltr .total-dues-val{
padding-right: 12px;

}
.rtl .dues-details li div,.rtl .total-dues-val{
padding-left: 12px;

}
.separator{
    display: block !important;
    height: 1px;
    width: 100%;
    background: #4F4D61;
    margin-bottom: 8px;
 
}
.ltr .separator ,.ltr .total-dues-val{
  margin-left: -13px;
}
.rtl .separator ,.rtl .total-dues-val{
  margin-right: -13px;
}
.due-block .due-payments div.selected{
    background: rgba(13, 69, 111, 0.1);
    border: 2px solid #0D456F;
}
.exchange-icons{
  display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    font-size: 19px;
    color: #4F4D61;
}

.due-payments .check {
  display: block;
  position: relative;
  padding-left: 35px;
  padding-top:2px;
  height: 100%;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.rtl .due-payments .check{
  padding-right: 35px;
  padding-left: 0px;
}
.due-payments .checkmark {
  position: absolute;
    top: 5px;
    right: 0;
    height: 18px;
    width: 18px;
    background-color: white;
    border: 2px solid #4F4D61;
    border-radius: 2px;

}
.rtl .due-payments .checkmark{
  left: 0;
}
.due-payments .check input:checked ~ .checkmark {
  background-color: #0D456F ;
    border-color: #0D456F;
}
.due-payments .check input:checked 
.due-payments .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.due-payments input:checked ~ .checkmark:after {
  display: block;
}

.due-payments .checkmark:after {
  left: 5px;
  top: 0.5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
 
}

.due-payment__amount {
  text-align: end;
  font-weight:500 !important
}

@media(max-width:700px){
 
  .due-payments .check ,.due-payments div span {
    font-size: 13px;}
  .due-block .due-payments p{
    line-height: 2;
  }
  .total-pay span:first-child{
    font-size: 14px ;
  }
  .total-pay span:nth-child(2){
    font-size: 16px;
  }
}
@media (max-width:576px) {
  .recharge > button {
    font-size: 13px; 
}
}
@media (max-width:500px){
  .due-payments .check ,.due-payments div span {
  font-size: 11px;}
  .due-block .due-payments div{
    line-height: 2;
  }
}
@media(max-width:450px){
  .min-span{
  font-size: 11px;
}
  .due-block .due-payments div {
    padding: 8px 6px;
  }
}
@media(max-width:400px){
  .due-block .due-payments div {
    line-height: 1.2;
  }
}
.due-parent .due-block{
  height: 100%;
}
.cancel-margin{
  margin-top: 0px !important;
}
::-webkit-scrollbar {
    width: 8px;
}
::-webkit-scrollbar-thumb {
    background: #888;
}
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.pylon-icon-Warning:before{
  font-size: 28px;
}
</style>
